/* eslint-disable indent,arrow-body-style,max-len,no-return-assign */
// @flow
import React from 'react';
import { Box } from 'grommet';
import { History, Match } from 'react-router-dom';
import { withRouter } from 'react-router';
import ShaftIcon from 'esm-web-pro/components/layout/sidePanel/icons/ShaftIcon';
import PillarIcon from 'esm-web-pro/components/layout/sidePanel/icons/PillarIcon';
import PoPIcon from 'esm-web-pro/components/layout/sidePanel/icons/PoPIcon';
import WallPointIcon from 'esm-web-pro/components/layout/sidePanel/icons/WallPointIcon';
import LineCutIcon from 'esm-web-pro/components/layout/sidePanel/icons/LineCutIcon';
import GisPointIcon from 'esm-web-pro/components/layout/sidePanel/icons/GisPointIcon';
import PillarUndergroundConnectionIcon
    from 'esm-web-pro/components/layout/sidePanel/icons/PillarUndergroundConnectionIcon';
import WallPointUndergroundConnectionIcon
    from 'esm-web-pro/components/layout/sidePanel/icons/WallPointUndergroundConnectionIcon';
import CabinetUndergroundConnectionIcon
    from 'esm-web-pro/components/layout/sidePanel/icons/CabinetUndergroundConnectionIcon';
import CabinetIcon from 'esm-web-pro/components/layout/sidePanel/icons/CabinetIcon';
import ForkIcon from 'esm-web-pro/components/layout/sidePanel/icons/Fork';
import GisLineIcon from 'esm-web-pro/components/layout/sidePanel/icons/GisLineIcon';

type Props = {
    object: Object,
    history: History,
    match: Match,
    onClick: Function,
}

const DropdownItem = (props: Props) => {
    const {
        object, history, match, onClick,
    } = props;
    const [isHover, setIsHover] = React.useState(false);

    const handleMouseEnter = () => setIsHover(true);

    const handleMouseExit = () => setIsHover(false);

    const setIcon = (point) => {
        switch (point.type) {
            case 'shaft':
                return <ShaftIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            case 'pillar':
                if (point.underground_connection) {
                    return <PillarUndergroundConnectionIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
                }
                return <PillarIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            case 'pop':
                return <PoPIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            case 'wallpoint':
                if (point.underground_connection) {
                    return <WallPointUndergroundConnectionIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
                }
                return <WallPointIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            case 'cabinet':
                if (point.underground_connection) {
                    return <CabinetUndergroundConnectionIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
                }
                return <CabinetIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            case 'linecut':
                return <LineCutIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            case 'fork':
                return <ForkIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            case undefined:
                return <GisLineIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
            default:
                return <GisPointIcon style={{ height: '22px', width: '22px', padding: '1.5px 0px 0px 1.5px' }} />;
        }
    };

    return (
        <Box
            style={{
                minHeight: '25px',
                minWidth: '250px',
                display: 'flex',
                flexDirection: 'row',
                margin: '3px 12px',
                backgroundColor: isHover ? 'lightgray' : 'white',
            }}
            onClick={() => {
                history.push(`${match.url}/layer/${object.type || 'gisline'}/${object.identity}`);
                if (onClick) onClick();
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseExit}
            className="map-search-dropdown-item"
        >
            <div
                style={{
                    height: '25px',
                    width: '25px',
                    border: `3px solid ${object.infrastructure_provider.color || 'gray'}`,
                    borderRadius: '6px',
                    backgroundColor: 'inherit',
                    pointerEvents: 'none',
                }}
            >
                {setIcon(object)}
            </div>
            <div style={{ padding: '3.5px 0px 0px 3.5px', fontSize: '16px', backgroundColor: 'inherit' }}>
                {object.ref}
                {object.alias && !object.provider_ref && ` (${object.alias})`}
                {object.alias && object.provider_ref && ` (${object.alias} / ${object.provider_ref})`}
                {!object.alias && object.provider_ref && ` (${object.provider_ref})`}
            </div>
        </Box>
    );
};

export default withRouter(DropdownItem);
